import { DayOfWeek } from 'types/tenants.ts';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations.ts';

/** The selected weekday: classic's primary green darkened by a fifth, the new design's darker primary step. */
const PRIMARY_DARK_FILL =
    'border-[color-mix(in_srgb,var(--color-primary)_80%,black)] bg-[color-mix(in_srgb,var(--color-primary)_80%,black)] new:border-primary-strong new:bg-primary-strong';

interface Props {
    /** Prefixes each pill's accessible name, so a page with several pickers tells them apart. */
    label: string;
    value: DayOfWeek;
    disabled: boolean;
    onChange: (day: DayOfWeek) => void;
}

/** A row of Monday–Sunday pills, one of them selected. */
const WeekdayPicker = ({ label, value, disabled, onChange }: Props): JSX.Element => (
    <div className="flex flex-wrap gap-1.5">
        {Object.values(DayOfWeek).map((day) => {
            const selected = day === value;
            return (
                <button
                    type="button"
                    key={day}
                    aria-pressed={selected}
                    aria-label={`${label}: ${t(`financial-conditions.weekday.${day}`)}`}
                    title={t(`financial-conditions.weekday.${day}`)}
                    disabled={disabled}
                    onClick={() => onChange(day)}
                    className={cn(
                        'min-w-[46px] cursor-pointer rounded-[9px] border px-2 py-[9px] text-[13.5px] disabled:pointer-events-none',
                        selected
                            ? cn('text-primary-foreground font-bold', PRIMARY_DARK_FILL)
                            : 'border-divider bg-paper text-fg'
                    )}
                >
                    {t(`financial-conditions.weekday-short.${day}`)}
                </button>
            );
        })}
    </div>
);

export default WeekdayPicker;
